var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-view"},[_c('div',{staticStyle:{"text-align":"left"}},[(_vm.parent && !_vm.parent.data.inDialog)?_c('md-button',{on:{"click":function($event){return _vm.back();}}},[_vm._v("Back")]):_vm._e()],1),_c('viewer',{attrs:{"content":true,"embed":true,"mode":_vm.mode,"nid":_vm.nid,"sid":null,"elements":_vm.saveData.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }